import React from 'react'
import {Collapse} from 'reactstrap'

const CollapseStatus = {
    CLOSED: 'closed',
    OPENING: 'opening',
    OPENED: 'opened',
    CLOSING: 'closing',
}

const withCollapsed = (WrappedComponent) => {
    return ({toggleEl, defaultOpen = false, ...rest}) => {
        const [collapsed, setCollapsed] = React.useState(defaultOpen)
        const [status, setStatus] = React.useState(CollapseStatus.CLOSED)

        const toggleCollapse = () => {
            setCollapsed(!collapsed)
        }

        return (
            <>
                {toggleEl({collapsed, toggleCollapse})}
                <Collapse isOpen={collapsed}>
                    <WrappedComponent {...rest} collapsed={collapsed} toggleCollapse={toggleCollapse} />
                </Collapse>
            </>
        )
    }
}

export default withCollapsed
